import type { ReactNode } from "react";

type RadioOption<T extends string> = {
  value: T;
  label: ReactNode;
  description?: ReactNode;
};

export function RadioGroup<T extends string>({
  legend,
  name,
  value,
  options,
  onChange,
}: {
  legend: string;
  name: string;
  value: T;
  options: RadioOption<T>[];
  onChange: (value: T) => void;
}) {
  return (
    <fieldset className="grid gap-2">
      <legend className="text-sm font-semibold text-text">{legend}</legend>
      {options.map((option) => (
        <label
          key={option.value}
          className="card-paper flex min-h-12 items-start gap-3 p-3 text-sm text-text transition hover:border-accent-200 hover:bg-surface"
        >
          <span className="relative mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center">
            <input
              checked={value === option.value}
              className="peer h-5 w-5 appearance-none rounded-pill border border-border bg-surface transition checked:border-accent-600 focus-visible:outline-none focus-visible:shadow-[var(--shadow-ring-focus)]"
              name={name}
              type="radio"
              value={option.value}
              onChange={() => onChange(option.value)}
            />
            <span className="pointer-events-none absolute h-2.5 w-2.5 rounded-pill bg-accent-600 opacity-0 transition peer-checked:opacity-100" />
          </span>
          <span>
            <span className="block font-semibold text-text">{option.label}</span>
            {option.description ? (
              <span className="mt-1 block leading-6 text-text-muted">{option.description}</span>
            ) : null}
          </span>
        </label>
      ))}
    </fieldset>
  );
}
